"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.CloseButton = styled_components_1.default.span `
  position: absolute;
  top: -20px;
  right: -10px;
  z-index: 130;
  color: #fff;
  cursor: pointer;
`;
